var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailBoxesLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152 -851) translate(101 90) translate(0 744) translate(51 16) translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.724,
    height: 5.673,
    x: 5.067,
    y: 0.585,
    stroke: "currentColor",
    strokeWidth: 1.169,
    rx: 0.622
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    d: "M13.908 30.792c-.927 0-12.773-.109-12.97-.109-.47 0-.938-.394-.938-.824v-12.27c0-2.211 2.499-6.454 6.883-6.95 4.385-.496 8.155 4.018 8.155 7.332V29.86c-.441.622-.818.933-1.13.933z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.169,
    d: "M5.06 5.806v5.236c.534-.269 1.446-.403 2.734-.403h22.914c3.456 0 7.292 3.47 7.292 6.95v12.27c0 .524-.459.824-.793.824H.938c-.47 0-.938-.394-.938-.824v-12.27c0-2.211 2.499-6.454 6.883-6.95 4.385-.496 8.155 4.018 8.155 7.332 0 2.21-.04 6.348-.12 12.413"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.169,
    d: "M21.857 30.792L21.857 38.879"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBoxesLarge);
export default __webpack_public_path__ + "static/media/mail-boxes-large.610787df.svg";
export { ForwardRef as ReactComponent };